import React from 'react';

const Loading = () => {
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '200px', 
      width: '100%',
      flexDirection: 'column',
      gap: '12px'
    }}>
      <div style={{
        border: '4px solid var(--bg-sage)',
        borderTop: '4px solid var(--primary)',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        animation: 'spin 1s linear infinite'
      }} />
      <span style={{ fontSize: '0.85rem', color: 'var(--text-light)', fontWeight: 600 }}>Loading portal data...</span>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Loading;
